export default __webpack_public_path__ + "static/media/qty-caret-down.bc62df0e.svg";